export const CUSTOM_EVENT_SESSION_STORAGE = "CustomEvent_SessionStorage";
export const CUSTOM_EVENT_LOGIN_ACTIONS_ERROR = "CustomEvent_LoginActionsError";
